module.exports = function getResource(label, vars = []) {
    let resources = {
        done: 'Terminé',
        all: 'Tous',
        clear: 'Incolore',
        shade: 'Teinte'
    };
    return resources[label];
};
